import { jsx } from "react/jsx-runtime";
import { createSvgIcon } from "@mui/material";
const TrustIcon = createSvgIcon(
  /* @__PURE__ */ jsx("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx("g", { id: "Trust", children: /* @__PURE__ */ jsx(
    "path",
    {
      id: "Vector",
      d: "M8.6836 1.33334C7.5696 1.33334 6.66668 2.23627 6.66668 3.35027C6.66668 4.6456 8.92711 6.73235 9.89845 7.56902C10.1498 7.78569 10.5169 7.78569 10.7682 7.56902C11.7396 6.73235 14 4.6456 14 3.35027C14 2.23627 13.0971 1.33334 11.9831 1.33334C10.9218 1.33334 10.3333 2.09897 10.3333 2.09897C10.3333 2.09897 9.74494 1.33334 8.6836 1.33334ZM13.724 8.00001C13.4826 8.00001 13.2413 8.09205 13.0573 8.27605L10 11.3333H7.33334C7.14934 11.3333 7.00001 11.184 7.00001 11C7.00001 10.816 7.14934 10.6667 7.33334 10.6667H9.00001C9.55201 10.6667 10 10.2187 10 9.66668C10 9.11468 9.55201 8.66668 9.00001 8.66668H5.77084C5.06351 8.66668 4.38543 8.94726 3.88543 9.44793L1.33334 12L4.00001 14.6667L5.33334 13.3333H10.1146C10.4679 13.3333 10.8073 13.1927 11.0573 12.9427L14.3906 9.60938C14.7586 9.24138 14.7586 8.64405 14.3906 8.27605C14.2066 8.09205 13.9653 8.00001 13.724 8.00001Z",
      fill: "currentColor"
    }
  ) }) }),
  "Trust"
);
export {
  TrustIcon,
  TrustIcon as default
};
